<template lang="pug">
  .authorization
    .authorization__title {{ headerTitle }}
    .authorization__title--text {{ headerText }}
    .authorization__form.authorization__form_entry
      form(
        @submit.prevent="onSubmitMethod"
      )
        .auth-form__elem.auth-form__elem_button
          .form-elem
            .form-elem__body
              button.button.button_paint-main.button_full(
                @click="$emit('close')"
              ) Спасибо
</template>

<script>
export default {
  name: "AccessMsg",
  props: {
    headerTitle: {
      type: String,
      default: ""
    },
    headerText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  methods: {
    onSubmitMethod(e) {
      e.preventDefault();
    }
  }
};
</script>
